module.exports = __webpack_public_path__ + "static/media/check-active.975a2a1b.png";